export interface TimeLeft {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export const EMPTY_TIME: TimeLeft = { days: 0, hours: 0, minutes: 0, seconds: 0 };

export const calculateTimeLeft = (targetDate: Date, now = Date.now()): TimeLeft => {
    const difference = targetDate.getTime() - now;

    if (difference <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
    };
};
